import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import './Login.css';
import { useAuth } from '../AuthContext';
import { API_AUTHENTICATE_URL, API_BASE_URL } from '../constants';


const Login: React.FC = () => {
  const [userName, setUserName] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [error, setError] = useState<string>('');
  const [success, setSuccess] = useState<string>('');
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  useEffect(() => {
    if (location.state?.type === 'success') {
      setSuccess(location.state.message);
    }

    if (location.state?.message) {
      setError(location.state.message);
    }
  }, [location.state]);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(API_AUTHENTICATE_URL, { username: userName, password });
      const token = data.access_token;
      if (token) {
        const user = await fetchUser(token);
        if (user) {
          login(token, user, data.expires);
          navigate('/', { state: { loginSuccess: true } });
        } else {
          setError('Anmeldung fehlgeschlagen. Bitte kontrollieren Sie Ihre Zugangsdaten und versuchen Sie den Vorgang noch einmal.');
        }
      } else {
        setError('Anmeldung fehlgeschlagen. Bitte kontrollieren Sie Ihre Zugangsdaten und versuchen Sie den Vorgang noch einmal.');
      }
    } catch (error: any) {
      handleError(error);
    }
  };

  const fetchUser = async (token: string) => {
    try {
      const { data } = await axios.get(`${API_BASE_URL}/user`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      return data.user;
    } catch (error) {
      handleError(error);
      return null;
    }
  };

  const handleError = (error: any) => {
    if (error.response?.data?.message) {
      setError(error.response.data.message);
    } else {
      setError('Anmeldung fehlgeschlagen. Bitte kontrollieren Sie Ihre Zugangsdaten und versuchen Sie den Vorgang noch einmal.');
    }
  };

  return (
    <>
      <div className="empty-container">
      </div>
      <div className="auth-container">
        <div className="p-3 border-bottom-grey">
          <h1 className="login-title">Anmeldung</h1>
        </div>
        <div className="p-3">
          <p className="login-subtitle">
            Steigen Sie mit Ihren Zugangsdaten in die IMC Nostrifizierungs-Plattform ein.
          </p>
          {success !== '' ?
            (success && <div className="alert alert-success">{success}</div>) :
            (error && <div className="alert alert-danger">{error}</div>)
          }
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor='username'> Benutzername (E-Mail-Adresse)</label>
              <input
                id='username'
                autoComplete="email"
                className="form-control"
                type="email"
                placeholder="Ihr Benutzername (E-Mail-Adresse)"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor='password'>Passwort</label>
              <input
                id='password'
                className="form-control"
                type="password"
                placeholder="Ihr Passwort"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="form-group bt">
              <button className="login-button" type="submit" disabled={userName === '' || password === ''} >Anmelden</button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Login;